import React, { Component } from 'react'

import { withStyles } from '@material-ui/core/styles'
import { FormControl } from '@material-ui/core';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import cs from 'classnames'

import './loginform.css'
import logo from '../../dp_dokument_logo.svg'

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  menu: {
    width: 200,
  },
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  formWrapper: {
    marginBottom: 20,
    boxSizing: 'border-box',
    minHeight: '155px'
  }
});

class LoginForm extends Component {
  state = {
    username: '',
    password: ''
  }
  handleInputChange = (event) => {
    const target = event.target,
      value = target.type ===
        'checkbox' ? target.checked : target.value,
      name = target.name
    this.setState({
      [name]: value
    });

  }
  onSubmit = (event) => {
    event.preventDefault()
    this.props.onSubmit(this.state.username, this.state.password)

  }


  render() {
    const { classes } = this.props
    const errors = this.props.errors || {}
    return (
      <div className="login__wrapper">
        <Paper className={cs('login__block card-panel', classes.paper)} elevation={2}>
          <div className="login__logo">
            <img src={logo} alt="" />
          </div>

          <form onSubmit={this.onSubmit}>
            <div className={classes.formWrapper}>
              <FormControl className={classes.formControl} fullWidth required>
                <InputLabel htmlFor="username" className={classes.label} required>Ім'я користувача</InputLabel>
                <Input id="username" className={classes.input} name="username" value={this.state.username}
                  onChange={this.handleInputChange}
                  endAdornment={<InputAdornment position="end"><Icon>account_circle</Icon></InputAdornment>}
                />
              </FormControl>

              <FormControl className={classes.formControl} fullWidth required>
                <InputLabel htmlFor="password" className={classes.label} required>Пароль</InputLabel>
                <Input id="password" type="password" className={classes.input} name="password" value={this.state.password}
                  onChange={this.handleInputChange}
                  endAdornment={<InputAdornment position="end"><Icon>vpn_key</Icon></InputAdornment>}
                />
              </FormControl>


              {
                errors.non_field_errors ?
                  <div className="pulse">
                    {errors.non_field_errors}
                  </div> : ""
              }
            </div>
            <Button className={classes.button} variant="contained" color="primary" type="submit" fullWidth>
              Вхід </Button>


          </form>
        </Paper>
      </div>
    )
  }
}

export default withStyles(styles)(LoginForm)


// WEBPACK FOOTER //
// ./src/components/LoginForm/LoginForm.js